import React, { Component } from 'react';
import { SofaButton } from '@sofology/sofologycomponents';

import './BasketUpsellItemHeader.scss';

import { UpsellTypes, UpsellModel, AddUpsellOptionModel } from 'models/Basket';
import { upsellContentItems, UpsellContentItem } from '../upsellContentItems';
import { BasketUpsellToggler } from 'pages/BasketPage';

interface OwnProps {
    upsellItem: UpsellModel;
    isUpsellAdding: boolean;
    isDisabled: boolean;
    onAddToOrder: (upsellItem: UpsellModel, selectedOption: AddUpsellOptionModel) => void;
}

interface OwnState {
    selectedOption: AddUpsellOptionModel | null;
    upsellContentItem: UpsellContentItem | null;
}

export class BasketUpsellItemHeader extends Component<OwnProps, OwnState> {
    constructor(props: OwnProps) {
        super(props);
        this.state = {
            selectedOption: this.props.upsellItem.options[0],
            upsellContentItem: this.getUpsellContentItem()
        };
    }

    handleAddToOrderClick = (upsellItem: UpsellModel, selectedOption: AddUpsellOptionModel) => (e: React.MouseEvent) => {
        e.stopPropagation();
        this.props.onAddToOrder(upsellItem, selectedOption);
    };

    handleSelectClick = (e: React.MouseEvent) => {
        e.stopPropagation();
    };

    handleSelectToggleChange = (amount: number | undefined): void => {
        const selectedOption = this.props.upsellItem.options.find(option => option.quantity === amount)!;
        this.setState({ selectedOption });
    };

    render(): JSX.Element {
        const { upsellItem, isUpsellAdding, isDisabled } = this.props;
        const selectedOption = this.state.selectedOption!;
        const upsellContentItem = this.state.upsellContentItem!;
        const shouldRenderUpsellToggler = upsellItem.options.length > 1 && !isUpsellAdding;

        return (
            <div className='upsell-item-header'>
                <div className={`upsell-item-header__line ${isDisabled ? 'upsell-item-header__line--disabled' : ''}`}>
                    <div className='upsell-item-header__title'>
                        <div className='upsell-item-header__title__image'>
                            <img src={upsellContentItem.logoImage} alt={upsellContentItem.title}></img>
                        </div>
                        <div className='upsell-item-header__info'>
                            {upsellContentItem.title}
                            <div className='upsell-item-header__info__subtitle'>
                                {isDisabled ? upsellContentItem.disabledSubtitle : upsellContentItem.subtitle}
                            </div>
                        </div>
                    </div>
                    <div className={`upsell-item-header__actions ${shouldRenderUpsellToggler ? 'upsell__actions' : ''}`}>
                        {shouldRenderUpsellToggler && this.renderToggler()}
                        {!isUpsellAdding && !isDisabled &&
                            <SofaButton
                                text='Add to order'
                                variant='secondary-rounded'
                                onClick={this.handleAddToOrderClick(upsellItem, selectedOption)}
                            />
                        }
                        {isDisabled && <p className='upsell-item-header__actions--disabled'>Unavailable</p>}
                    </div>
                </div>
                {isUpsellAdding && <div className='upsell-item-header__order-message'>
                    <i className='sa sa-trolley'></i> {upsellContentItem.orderMessage}
                </div>}
            </div>
        );
    }

    renderToggler(): JSX.Element {
        return (
            <BasketUpsellToggler
                options={this.props.upsellItem.options}
                content={this.state.upsellContentItem}
                selectedOption={this.state.selectedOption}
                handleSelectToggleChange={this.handleSelectToggleChange}
            />
        );
    }

    getUpsellContentItem(): UpsellContentItem {
        return upsellContentItems.find(u => u.id === this.props.upsellItem.type)!;
    }

    getOptionKey(option: AddUpsellOptionModel): string {
        return `${option.quantity}x ${UpsellTypes[this.props.upsellItem.type]}`;
    }
}